import { useParams } from "react-router";
//import CONSTANTS from "./CONSTANTS";

const urlParamSplitter = "::";

/**********
 * The logic here is a bit more complex than just returning the json for the 
 * origin app.
 * the origin app itself is just the name of the app.
 * An app, like Furia, might have query parameters that it was laucnhed with furia?pid=12343444
 * To keep those params through the auth flow, the are being sent to central as part of the app name, separated by ::
 * here, I will strip them from the app name (so I stay with only "furia") and add them properly to the {path:'...'} as this is what goes into the state= that comes back from opal (this is the context we have)
 * and it is added to the {url:"..."} which is the url we redirect after we authenticate
 *
 * When we come back from opal, there is no :originApp param. That value is in the ?state="..." so I need to force useOriginApp to use the value from state, the param inputOriginApp allows me this override.
 **********/
export default function useOriginApp(inputOriginApp=null){
    let { originApp }= useParams();
    if(inputOriginApp){
        originApp = inputOriginApp;
    }
    let extractedOriginApp = originApp;
    if(typeof extractedOriginApp === "string" && extractedOriginApp.includes(urlParamSplitter)){
        const parts = extractedOriginApp.split(urlParamSplitter);
        extractedOriginApp = parts[0];
        if(!apps[extractedOriginApp]){
            return {};
        }
        apps[extractedOriginApp].url += `?${parts[1]}=${parts[2]}`;
        apps[extractedOriginApp].path = originApp;
    }
    return apps[extractedOriginApp] || {};
}

export const apps = {
    "oh-requests":{
        name: "Occupational Health Requests",
        path: "oh-requests",
        url:  "/oh-requests",
        ssoOnly: false
    },
    "oh-requests-admin":{
        name: "Occupational Health Requests - Admin dashboard",
        path: "oh-requests-admin",
        url:  "/oh-requests-admin",
        ssoOnly: true
    },
    sitelms:{
        name: "MedStar Health sitelms.org",
        path: "sitelms",
        url:  process.env.REACT_APP_SITELMS_SSO_LINK,
        ssoOnly: false,
        loginPage: "sitelms"
    },
    furia:{ //TOBEDELETED once we have gpt.medstar.net and we fully go live
        name: "MedstarGPT",
        path: "furia",
        url:  "https://sapphire.medstarapps.net/central-furia/start-auth-logic",
        ssoOnly: true
    }
};
